var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cablesTableContainer" }, [
    _c(
      "div",
      { staticClass: "cableTableSection" },
      [
        _c("h4", [_vm._v("Origin")]),
        _vm._v(" "),
        _vm._l(_vm.origin, function(cable, index) {
          return _c("p", { key: index }, [_vm._v(_vm._s("CB: " + cable.cb_id))])
        })
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "cableTableSection" },
      [
        _c("h4", [_vm._v("Destination")]),
        _vm._v(" "),
        _vm._l(_vm.destination, function(cable, index) {
          return _c("p", { key: index }, [_vm._v(_vm._s("CB: " + cable.cb_id))])
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2505e1ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2505e1ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/InsidePlan/CablesTable.vue
// module id = null
// module chunks = 